import {Box, SxProps, Theme} from "@mui/material";
import {PropsWithChildren} from "react";
import {rise, fadeSlideUp} from "./keyframes";

type EntranceProps = PropsWithChildren<{
  delay?: number;
  variant?: "rise" | "slide";
  sx?: SxProps<Theme>;
}>;

const EASING = {
  rise: "ease-out",
  slide: "ease",
};

const DURATION = {
  rise: "0.5s",
  slide: "0.35s",
};

const KEYFRAMES = {
  rise,
  slide: fadeSlideUp,
};

export const Entrance = ({children, delay = 0, variant = "rise", sx}: EntranceProps) => (
  <Box
    sx={{
      opacity: 0,
      animation: `${KEYFRAMES[variant]} ${DURATION[variant]} ${EASING[variant]} ${delay}s forwards`,
      ...sx,
    }}
  >
    {children}
  </Box>
);
